export const AI_WEB_ENTRY_MISC_INFO_KEYWORD = 'CreatedFrom: AIWebEntry.';

/** Supplier IMA draft staging parked on Invoice.MiscInfo. */
const META = /<UITempMetadata>[\s\S]*?<\/UITempMetadata>/;

function tagValue(xml: string, name: string): string | undefined {
    return xml.match(new RegExp(`<${name}>([\\s\\S]*?)</${name}>`))?.[1] || undefined;
}

export function buildAiWebEntryMiscInfo(
    existingMiscInfo?: string | null,
    documentFileName?: string | null,
    customData?: unknown
): string {
    const rest = (existingMiscInfo ?? '').replace(META, '');
    const customDataText = customData != null ? encodeURIComponent(JSON.stringify(customData)) : '';

    return (
        '<UITempMetadata><AIWebEntry>' +
        `<Keyword>${AI_WEB_ENTRY_MISC_INFO_KEYWORD}</Keyword>` +
        `<File>${documentFileName ?? ''}</File>` +
        `<CustomData>${customDataText}</CustomData>` +
        '</AIWebEntry></UITempMetadata>' +
        rest
    );
}

export function parseAiWebEntryMiscInfo(miscInfo?: string | null): {
    isAiWebEntry: boolean;
    guidFileName?: string;
    customData?: unknown;
    cleanedMiscInfo: string | null;
} {
    const block = miscInfo?.match(META)?.[0];
    if (!block) {
        return { isAiWebEntry: false, cleanedMiscInfo: miscInfo ?? null };
    }

    const customDataText = tagValue(block, 'CustomData');
    let customData: unknown;
    if (customDataText) {
        try {
            customData = JSON.parse(decodeURIComponent(customDataText));
        } catch {
            // ignore corrupt staging
        }
    }

    return {
        isAiWebEntry: true,
        guidFileName: tagValue(block, 'File') || undefined,
        customData,
        cleanedMiscInfo: miscInfo!.replace(META, '').trim() || null,
    };
}
